import { useEffect, useState } from 'react'
import { Container, Typography } from '@mui/material'
import { PieChart } from '@mui/x-charts/PieChart'
import { useTheme } from '@mui/material/styles'
import { HighlightItemData } from '@mui/x-charts/context'
import Title from '../title/Title'
import { PieItemIdentifier } from '@mui/x-charts'
import React from 'react'

// interface DataItem {
//   value: number
//   color: string
//   title: string
// }

// interface PieProps {
//   data: DataItem[]
//   onSelectionChange: (selected: HighlightItemData | null) => void
//   selected: HighlightItemData | null
// }

// function Pie({ data, onSelectionChange, selected }: PieProps) {

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
})

function Pie({ data, onSelectionChange, selected }) {
  const theme = useTheme()

  const [selectedItem, setSelectedItem] = useState(null)
  const [hoveredItem, setHoveredItem] = useState(null)

  useEffect(() => {
    if (selected) {
      setSelectedItem(selected)
    } else {
      resetSelection()
    }
  }, [selected])

  const resetSelection = () => {
    setSelectedItem(null)
    setHoveredItem(null)
  }

  const handleHighlightChange = (highlight) => {
    setHoveredItem(highlight)
  }

  const handleItemClick = (_event, pieItemIdentifier) => {
    if (selectedItem?.dataIndex === pieItemIdentifier?.dataIndex) {
      resetSelection()
      onSelectionChange(null)
    } else {
      setSelectedItem(pieItemIdentifier)
      setHoveredItem(pieItemIdentifier)
      onSelectionChange(pieItemIdentifier)
    }
  }

  const getHighlightedItem = () => selectedItem || hoveredItem

  const getValue = () => {
    const activeItem = selectedItem || hoveredItem

    if (
      activeItem === null ||
      typeof activeItem.dataIndex !== 'number' ||
      !data[activeItem.dataIndex]
    ) {
      return data.reduce((acc, item) => acc + item.value, 0)
    } else {
      return data[activeItem.dataIndex].value
    }
  }

  return (
    <Container
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        height: 350,
        overflow: 'visible',
      }}
    >
      <PieChart
        series={[
          {
            id: 'A',
            highlightScope: { highlight: 'item' },
            highlighted: { additionalRadius: 10 },
            data,
            innerRadius: '80%',
            outerRadius: '100%',
            paddingAngle: 2.5,
            cornerRadius: 0,
            startAngle: 0,
            endAngle: 360,
            // cx: "62%",
            // cy: "50%",
          },
        ]}
        slotProps={{ legend: { hidden: true } }}
        sx={{
          paddingLeft: 8,
          scale: 0.95,
          overflow: 'visible',
          '.MuiChart-highlighted': {
            fill: 'transparent',
            strokeWidth: 2,
          },
        }}
        onHighlightChange={handleHighlightChange}
        highlightedItem={getHighlightedItem()}
        onItemClick={handleItemClick}
        tooltip={{ trigger: 'none' }}
      />
      <Container
        sx={{
          position: 'absolute',
          left: -10,

          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <Title
          highlighted={getHighlightedItem()?.dataIndex ?? null}
          data={data}
        />
        <Typography
          sx={{
            mt: 1,
            fontSize: theme.typography.h3.fontSize,
            color: '#373B47',
            justifySelf: 'center',
            fontWeight: 700,
          }}
        >
          {dollarFormat.format(getValue())}
        </Typography>
      </Container>
    </Container>
  )
}

export default Pie
